import { render, staticRenderFns } from "./aboutJIJE.vue?vue&type=template&id=0ddb5b51"
import script from "./aboutJIJE.vue?vue&type=script&lang=js"
export * from "./aboutJIJE.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports